export function assertFullfilled<T>(item: PromiseSettledResult<T>): item is PromiseFulfilledResult<T> {
    return item.status === "fulfilled";
}

export function assertObjectNotNullOrVoid<T>(item: T | void | null | undefined): item is T {
    return typeof item === 'object' && item !== null && item !== undefined;
}